module.exports = __webpack_public_path__ + "img/filter.f63f9102.svg";